import styled from 'styled-components';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';

export const BaseLayout = styled(Vertical).attrs({ center: true, gap: 0 })``;

export const TopClearance = styled(Horizontal).attrs({ center: true })`
  height: calc(8 * var(--unit));
`;

export const CardOrPackRelativeWrapper = styled(Horizontal)`
  justify-content: center;
  align-items: flex-start;
  position: relative;
  isolation: isolate;
  width: 100%;
  max-width: 320px;
  --stripe-height: 50px;
  --pack-aspect-ratio: 0.65217;
`;

export const CardWrapper = styled.div`
  width: calc(
    100% * var(--card-aspect-ratio) / var(--pack-aspect-ratio) - var(
        --double-unit
      )
  );
  aspect-ratio: var(--card-aspect-ratio);
`;
